/**
 * @generated SignedSource<<6ea608bcd63a7be373af167e9d59647e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_item" | "PdpSharedSocialShareEmail_item" | "PdpSharedSocialShareFacebook_item" | "PdpSharedSocialSharePinterest_item" | "useAuctionState_item">;
  readonly " $fragmentType": "PdpRespIconBubbles_item";
};
export type PdpRespIconBubbles_item$key = {
  readonly " $data"?: PdpRespIconBubbles_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialSharePinterest_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialShareFacebook_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialShareEmail_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbleShare_item"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useAuctionState_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "0a2e6ef06d9debacb760cc3ab06e331a";

export default node;
